import React, { useCallback, useRef, useEffect, useState } from 'react';
import {
  FiLogIn,
  FiMail,
  FiLock,
  FiKey,
  FiMessageCircle,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';
import { rgb } from 'polished';
import {
  FaConnectdevelop,
  FaLock,
  FaHandPointUp,
  FaCertificate,
  FaTicketAlt,
  FaVideo,
  FaAward,
  FaSlideshare,
  FaKey,
  FaPlus,
  FaMinus,
} from 'react-icons/fa';
import { MdColorLens, MdMessage } from 'react-icons/md';
import { AiFillSafetyCertificate } from 'react-icons/ai';
import { IconType } from 'react-icons/lib';
import { ContactIcons, WhatsappIcon } from '../../components/Menu';
import Whatsapp from '../../components/Whatsapp';
import { logo } from '../../config';
import { Container, ContainerWhite } from './styles';
import Input from '../../components/Input';
import Button from '../../components/Button';
import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';

import { Pattern } from '../../styles/ThemeComponents';
import ShowDiv from '../../components/ShowOnScroll';
import VideoBackground from '../../components/VideoBackground';
import TextPopper from '../../components/TextPopper';
import Scroller from '../../components/Scroller';

import Vimeo from '../../components/Vimeo';

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Sobre: React.FC = () => {
  const [active, setActive] = useState(false);
  return (
    <>
      <ContainerWhite id="sobre" background="none">
        <h2
          className="titleLine"
          style={{
            justifyContent: 'center',
            display: 'inline-block',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {' '}
          O Movimenta
        </h2>

        <div className="p50 p600">
          <p>
            O Movimenta é um evento que conecta jovens estudantes do ensino
            médio ao
{' '}
            <strong>empreendedorismo como um jeito de ser o mundo.</strong>
            <br />
            <br />
            Um encontro exclusivo para você ficar ligado e se conectar com seu
            futuro.
            <br />
            <br />
            <strong>
              {' '}
              Um evento que conecta você aos desafios e profissões do futuro.
              <br />
              <br />
              Seja empreendedor da sua vida.
            </strong>
          </p>
        </div>
        <a href="https://www.youtube.com/watch?v=hnVxbROTA1g">
          <div className="titleSkewRightDark">
            <h3 className="titleSkewRightDark">ASSISTA NO NOSSO YOUTUBE</h3>
          </div>
        </a>
        <div
          className="separator"
          style={{ width: '80%', maxWidth: '100%', margin: '30px auto' }}
        />

        <h2
          className="titleLine"
          style={{
            justifyContent: 'center',
            display: 'inline-block',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {' '}
          Para quem é o Movimenta?
        </h2>

        <div className="p50 p600">
          <p>
            O Movimenta é destinado para os
{' '}
            <strong>alunos do ensino médio de todas as escolas</strong>
, pais e
            professores. Porém, todos que têm interesse no assunto são
            bem-vindos neste espaço de muito conteúdo.
</p>
        </div>
        <div
          className="separator"
          style={{ width: '80%', maxWidth: '100%', margin: '30px auto' }}
        />
        <h2
          className="titleLine"
          style={{
            justifyContent: 'center',
            display: 'inline-block',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {' '}
          Preciso pagar alguma taxa? 
        </h2>

        <div className="p50 p600">
          <p>
            Não. As inscrições são totalmente gratuitas. O Movimenta é uma
            iniciativa do Sebrae RS com correalização da Startse.
          </p>
        </div>
        <a href="https://www.youtube.com/watch?v=hnVxbROTA1g">
          <div className="titleSkewRightDark">
            <h3 className="titleSkewRightDark">ASSISTA NO NOSSO YOUTUBE</h3>
          </div>
        </a>
        <div
          className="separator"
          style={{ width: '80%', maxWidth: '100%', margin: '30px auto' }}
        />
        <h2
          className="titleLine"
          style={{
            justifyContent: 'center',
            display: 'inline-block',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {' '}
          Por que devo participar?
        </h2>

        <div className="p50 p600">
          <p>
            Porque é um evento que traz uma visão simples e objetiva do
            <strong> empreendedorismo como um jeito de ser no mundo. </strong>
            <br />
              
            <br />
            A programação conta com temas atuais e em alta. Confira:
            <br />
            <br />
            <strong>
              O mundo está digital - novas tecnologias e as profissões do futuro
            </strong>
            <br />
            <br />
            O desenvolvimento tecnológico cresce cada vez mais de forma
            exponencial e impacta a sociedade como um todo, nosso comportamento,
            necessidades e interações. Por isso, vamos falar sobre os impactos
            das novas tecnologias no futuro dos jovens e nas profissões que
            ainda surgirão.
            <br />
            <br />
            <strong>
              Inovação - como criar e desenvolver negócios e soluções inovadoras
            </strong>
            <br />
            <br />
            De nada adianta falarmos de tecnologia se não utilizarmos a inovação
            para resolver antigos problemas, não é mesmo?
            <br />
            <br />
            Uma das características dos empreendedores jovens é o inconformismo
            com a realidade atual e a vontade de causar impacto na sociedade. 
            Por isso, abordaremos a inovação como um complemento do tema de
            novas tecnologias e para inspirar os jovens para o mundo do
            empreendedorismo.
            <br />
            <br />
            <strong>
              Soft skills - Você sabia que as Soft skills são as competências
              que mais serão exigidas no mundo do trabalho?
            </strong>
            <br />
            <br />
            Pensando nisso, precisamos cada vez mais fortalecer nossas
            competências para o mundo do trabalho. Num mercado cada vez mais
            competitivo e onde as mudanças na sociedade ocorrem de forma mais
            dinâmica, as soft skills se tornam fatores determinantes para o
            destaque dos jovens no mercado.
          </p>
        </div>
        <a href="https://www.youtube.com/watch?v=hnVxbROTA1g">
          <div className="titleSkewRightDark">
            <h3 className="titleSkewRightDark">ASSISTA NO NOSSO YOUTUBE</h3>
          </div>
        </a>
      </ContainerWhite>
    </>
  );
};
export default Sobre;
